module.exports = __webpack_public_path__ + "img/less3_green.66673959.png";